// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/Reports/Reports.css */

.reports-container {
  color: white;
  font-family: Verdana, Arial, Helvetica, sans-serif;
  position: relative;
  width: 100%;
  height: 85vh;
  max-height: 85vh;
  padding: 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* Header container for icon and title */
.headerr-container {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 5px;
}

.home-icon {
  width: 35px;
  height: 35px;
  margin-left: 1rem;
  transition: transform 0.2s ease;
  border-radius: 50%;
  border: 3px solid #364C63;  
  border-color: #EF6F53;  
  padding: 5px;
  position: absolute;
  left: 0;
  z-index: 1;
  background-color: white;
}

.home-icon:hover {
  transform: scale(1.1);
  border-color: #aaa;  
}

.reports-title {
  color: #EF6F53;
  text-align: center;
  margin-bottom: 5px;
  font-size: 1.5rem;
  flex-shrink: 0;
  font-weight: 700;
  width: 100%;
  margin-left: 0;
}

.error-message {
  background-color: rgba(255, 0, 0, 0.1);
  color: #ff6b6b;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 8px;
  text-align: center;
  flex-shrink: 0;
  font-size: 0.9rem;
}

.loading {
  text-align: center;
  padding: 10px;
  font-size: 1.1rem;
  color: #EF6F53;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reports-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 6px;
  flex-shrink: 0;
}

.tab-button {
  background-color: #1e1e1e;
  color: white;
  border: none;
  padding: 6px 12px;
  margin: 0 3px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
}

.tab-button:hover {
  background-color: #333;
}

.tab-button.active {
  background-color: #EF6F53;
  color: white;
}

.filter-section {
  background-color: #1e1e1e;
  padding: 6px;
  border-radius: 8px;
  margin-bottom: 6px;
  flex-shrink: 0;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
}

.filter-group {
  flex: 1 1;
  min-width: 120px;
}

.form-labell {
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
  text-align: left;
  color: #EF6F53;
}

.form-inputt {
  width: 100%;
  padding: 3px;
  border: 1px solid #444;
  border-radius: 4px;
  font-size: 0.8rem;
  background-color: #253e5897;
  color: white;
  height: 24px;
}

.filter-button {
  background-color: #EF6F53;
  color: white;
  border: none;
  padding: 3px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;
  height: 24px;
  font-size: 0.8rem;
}

.filter-button:hover {
  background-color: #d45e45;
}

.content-area {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.reports-content {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}

.reports-table-container {
  overflow-x: auto;
  overflow-y: auto;
  margin-bottom: 6px;
  flex: 1 1;
  min-height: 0;
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #1e1e1e;
  border-radius: 8px;
  overflow: hidden;
  font-size: 0.85rem;
}

.reports-table th,
.reports-table td {
  padding: 5px;
  text-align: left;
  border-bottom: 1px solid #333;
}

.reports-table th {
  background-color: #253e58;
  position: sticky;
  top: 0;
  z-index: 1;
  font-size: 0.8rem;
  padding: 6px;
}

.reports-table tr:hover {
  background-color: #2a2a2a;
}

.message-cell {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.caption {
  font-size: 0.75rem;
  color: #aaa;
  margin-top: 2px;
}

.status-badge {
  display: inline-block;
  padding: 1px 5px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: bold;
}

.status-sent {
  background-color: rgba(76, 175, 80, 0.2);
  color: #4CAF50;
}

.status-delivered {
  background-color: rgba(33, 150, 243, 0.2);
  color: #2196F3;
}

.status-read {
  background-color: rgba(156, 39, 176, 0.2);
  color: #9C27B0;
}

.status-failed {
  background-color: rgba(244, 67, 54, 0.2);
  color: #F44336;
}

.status-pending {
  background-color: rgba(255, 152, 0, 0.2);
  color: #FF9800;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin: 0;
}

.page-button {
  background-color: #1e1e1e;
  color: white;
  border: none;
  padding: 3px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 0.8rem;
  margin: 0 2px;
}

.page-button:hover:not(:disabled) {
  background-color: #333;
}

.page-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  margin: 0 4px;
  color: #ccc;
  font-size: 0.8rem;
}

.no-data {
  text-align: center;
  padding: 8px;
  color: #888;
  font-style: italic;
  font-size: 0.9rem;
}

.summary-container {
  padding: 8px;
  background-color: #1e1e1e;
  border-radius: 8px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.summary-container h2 {
  color: #EF6F53;
  text-align: center;
  margin-bottom: 8px;
  font-size: 1.45rem;
}

.status-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
  margin-top: 2rem;
}

.status-card {
  flex: 1 1;
  min-width: 90px;
  max-width: 140px;
  padding: 8px;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
}

.status-card h3 {
  font-size: 0.9rem;
  margin-bottom: 3px;
}

.status-count {
  font-size: 1.8rem;
  font-weight: bold;
}

.status-card.sent {
  background-color: rgba(76, 175, 80, 0.2);
  border: 1px solid rgba(76, 175, 80, 0.5);
}

.status-card.delivered {
  background-color: rgba(33, 150, 243, 0.2);
  border: 1px solid rgba(33, 150, 243, 0.5);
}

.status-card.read {
  background-color: rgba(156, 39, 176, 0.2);
  border: 1px solid rgba(156, 39, 176, 0.5);
}

.status-card.failed {
  background-color: rgba(244, 67, 54, 0.2);
  border: 1px solid rgba(244, 67, 54, 0.5);
}

.status-card.pending {
  background-color: rgba(255, 152, 0, 0.2);
  border: 1px solid rgba(255, 152, 0, 0.5);
}

.total-summary {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 8px;
  border-radius: 8px;
  text-align: center;
  margin-top: 3rem;
}

.total-summary h3 {
  color: #EF6F53;
  margin-bottom: 5px;
  font-size: 1rem;
}

.total-count {
  font-size: 2.2rem;
  font-weight: bold;
  color: white;
}

.chart-container {
  padding: 5px;
  background-color: #1e1e1e;
  border-radius: 8px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.chart-container h2 {
  color: #EF6F53;
  text-align: center;
  margin-bottom: 1px;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/Reports/Reports.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,YAAY;EACZ,kDAAkD;EAClD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["/* src/components/routes/Forms/Reports/Reports.css */\n\n.reports-container {\n  color: white;\n  font-family: Verdana, Arial, Helvetica, sans-serif;\n  position: relative;\n  width: 100%;\n  height: 85vh;\n  max-height: 85vh;\n  padding: 8px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header container for icon and title */\n.headerr-container {\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin-bottom: 5px;\n}\n\n.home-icon {\n  width: 35px;\n  height: 35px;\n  margin-left: 1rem;\n  transition: transform 0.2s ease;\n  border-radius: 50%;\n  border: 3px solid #364C63;  \n  border-color: #EF6F53;  \n  padding: 5px;\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  background-color: white;\n}\n\n.home-icon:hover {\n  transform: scale(1.1);\n  border-color: #aaa;  \n}\n\n.reports-title {\n  color: #EF6F53;\n  text-align: center;\n  margin-bottom: 5px;\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  font-weight: 700;\n  width: 100%;\n  margin-left: 0;\n}\n\n.error-message {\n  background-color: rgba(255, 0, 0, 0.1);\n  color: #ff6b6b;\n  padding: 5px;\n  border-radius: 5px;\n  margin-bottom: 8px;\n  text-align: center;\n  flex-shrink: 0;\n  font-size: 0.9rem;\n}\n\n.loading {\n  text-align: center;\n  padding: 10px;\n  font-size: 1.1rem;\n  color: #EF6F53;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.reports-tabs {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 6px;\n  flex-shrink: 0;\n}\n\n.tab-button {\n  background-color: #1e1e1e;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  margin: 0 3px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.85rem;\n}\n\n.tab-button:hover {\n  background-color: #333;\n}\n\n.tab-button.active {\n  background-color: #EF6F53;\n  color: white;\n}\n\n.filter-section {\n  background-color: #1e1e1e;\n  padding: 6px;\n  border-radius: 8px;\n  margin-bottom: 6px;\n  flex-shrink: 0;\n}\n\n.filter-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n.filter-group {\n  flex: 1;\n  min-width: 120px;\n}\n\n.form-labell {\n  font-size: 0.8rem;\n  font-weight: bold;\n  margin-bottom: 2px;\n  display: block;\n  text-align: left;\n  color: #EF6F53;\n}\n\n.form-inputt {\n  width: 100%;\n  padding: 3px;\n  border: 1px solid #444;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  background-color: #253e5897;\n  color: white;\n  height: 24px;\n}\n\n.filter-button {\n  background-color: #EF6F53;\n  color: white;\n  border: none;\n  padding: 3px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background-color 0.3s;\n  height: 24px;\n  font-size: 0.8rem;\n}\n\n.filter-button:hover {\n  background-color: #d45e45;\n}\n\n.content-area {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.reports-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n}\n\n.reports-table-container {\n  overflow-x: auto;\n  overflow-y: auto;\n  margin-bottom: 6px;\n  flex: 1;\n  min-height: 0;\n}\n\n.reports-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  overflow: hidden;\n  font-size: 0.85rem;\n}\n\n.reports-table th,\n.reports-table td {\n  padding: 5px;\n  text-align: left;\n  border-bottom: 1px solid #333;\n}\n\n.reports-table th {\n  background-color: #253e58;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  font-size: 0.8rem;\n  padding: 6px;\n}\n\n.reports-table tr:hover {\n  background-color: #2a2a2a;\n}\n\n.message-cell {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.caption {\n  font-size: 0.75rem;\n  color: #aaa;\n  margin-top: 2px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 1px 5px;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: bold;\n}\n\n.status-sent {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #4CAF50;\n}\n\n.status-delivered {\n  background-color: rgba(33, 150, 243, 0.2);\n  color: #2196F3;\n}\n\n.status-read {\n  background-color: rgba(156, 39, 176, 0.2);\n  color: #9C27B0;\n}\n\n.status-failed {\n  background-color: rgba(244, 67, 54, 0.2);\n  color: #F44336;\n}\n\n.status-pending {\n  background-color: rgba(255, 152, 0, 0.2);\n  color: #FF9800;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  margin: 0;\n}\n\n.page-button {\n  background-color: #1e1e1e;\n  color: white;\n  border: none;\n  padding: 3px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  font-size: 0.8rem;\n  margin: 0 2px;\n}\n\n.page-button:hover:not(:disabled) {\n  background-color: #333;\n}\n\n.page-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.page-info {\n  margin: 0 4px;\n  color: #ccc;\n  font-size: 0.8rem;\n}\n\n.no-data {\n  text-align: center;\n  padding: 8px;\n  color: #888;\n  font-style: italic;\n  font-size: 0.9rem;\n}\n\n.summary-container {\n  padding: 8px;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.summary-container h2 {\n  color: #EF6F53;\n  text-align: center;\n  margin-bottom: 8px;\n  font-size: 1.45rem;\n}\n\n.status-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.status-card {\n  flex: 1;\n  min-width: 90px;\n  max-width: 140px;\n  padding: 8px;\n  border-radius: 6px;\n  text-align: center;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);\n}\n\n.status-card h3 {\n  font-size: 0.9rem;\n  margin-bottom: 3px;\n}\n\n.status-count {\n  font-size: 1.8rem;\n  font-weight: bold;\n}\n\n.status-card.sent {\n  background-color: rgba(76, 175, 80, 0.2);\n  border: 1px solid rgba(76, 175, 80, 0.5);\n}\n\n.status-card.delivered {\n  background-color: rgba(33, 150, 243, 0.2);\n  border: 1px solid rgba(33, 150, 243, 0.5);\n}\n\n.status-card.read {\n  background-color: rgba(156, 39, 176, 0.2);\n  border: 1px solid rgba(156, 39, 176, 0.5);\n}\n\n.status-card.failed {\n  background-color: rgba(244, 67, 54, 0.2);\n  border: 1px solid rgba(244, 67, 54, 0.5);\n}\n\n.status-card.pending {\n  background-color: rgba(255, 152, 0, 0.2);\n  border: 1px solid rgba(255, 152, 0, 0.5);\n}\n\n.total-summary {\n  background-color: rgba(0, 0, 0, 0.2);\n  padding: 8px;\n  border-radius: 8px;\n  text-align: center;\n  margin-top: 3rem;\n}\n\n.total-summary h3 {\n  color: #EF6F53;\n  margin-bottom: 5px;\n  font-size: 1rem;\n}\n\n.total-count {\n  font-size: 2.2rem;\n  font-weight: bold;\n  color: white;\n}\n\n.chart-container {\n  padding: 5px;\n  background-color: #1e1e1e;\n  border-radius: 8px;\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n\n.chart-container h2 {\n  color: #EF6F53;\n  text-align: center;\n  margin-bottom: 1px;\n  font-size: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
